import { lazy } from "react";

export const Footer = lazy(() => import("./Footer"));
export const PublicNavbar = lazy(() => import("./PublicNavbar"));

// -------------For Candidate Landing page-------------------
export const CandidateFooter = lazy(() => import("./CandidateFooter"));
export const CandidateNavbar = lazy(() => import("./CandidateNavbar"));
